import { render } from "./SocialLinkModal.vue?vue&type=template&id=477eb870&scoped=true"
import script from "./SocialLinkModal.vue?vue&type=script&lang=js"
export * from "./SocialLinkModal.vue?vue&type=script&lang=js"

import "./SocialLinkModal.vue?vue&type=style&index=0&id=477eb870&scoped=true&lang=css"

import exportComponent from "/home/circleci/project/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-477eb870"]])

export default __exports__